import React from "react";

const CALENDLY_URL =
  "https://calendly.com/tanfrompeerpop/30-minute-meeting";

const FounderCtaLink = ({
  className = "",
  children = "Talk to a Founder",
  ...rest
}) => (
  <a
    href={CALENDLY_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={className}
    {...rest}
  >
    {children}
  </a>
);

export default FounderCtaLink;
